import {Component, Input} from '@angular/core';
import {EntityComponent} from '../share/entity-component';
import {ProfileModel} from '../../model';
import {SceneService} from '../scene.service';
import {Geometry, Line, LineBasicMaterial, Vector3} from 'three';
import { RendererService } from '../renderer.service';

@Component({
  selector: 'ng3-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent extends EntityComponent<ProfileModel> {
  _increment = 10;
  @Input()
  set increment(inc: number) {
    this._increment = inc;
  }
  get increment(): number {
    return this._increment;
  }

  @Input() start = 0;
  constructor(sceneService: SceneService, renderer: RendererService) {
    super(sceneService, renderer);
  }

  createEntity(model: ProfileModel) {
    const geo = new Geometry();
    for (let i = 0; i < model.points.length; i ++) {
      geo.vertices.push(new Vector3(this.start + i * this._increment, model.points[i], 0));
    }
    const result = new Line(geo, new LineBasicMaterial({ color: 'red'}) );
    result.name = 'profile1d';
    return result;
  }

  updateEntity(model: ProfileModel, entity: Line) {
    const geo = new Geometry();
    for (let i = 0; i < model.points.length; i ++) {
      geo.vertices.push(new Vector3(this.start + i * this._increment, model.points[i], 0));
    }
    entity.geometry = geo;
    return entity;
  }

  defaultModel(): ProfileModel {
    return new ProfileModel(
      [0, 5, 10, 15, 20, 15, 10, 5, 0]
    );
  }
}
